import styled from "styled-components";

export const OptInDialogHeaderDefaultBox = styled.div`
    @media ${({theme}) => `${theme.mediaQuery.mAndBelow} and ${theme.mediaQuery.landscape}`} {
        flex-direction: row; 
        justify-content: center;
    }
    display: flex; 
    flex-direction: column; 
    align-items: center;
    background-image: linear-gradient(transparent,${props => props.theme.colors.backgroundMiddleDark} 95%, ${props => props.theme.colors.backgroundMiddleDark} 100%);
    min-height: 30px;
    width: 100%;
`;


